import {Injectable, signal, WritableSignal} from "@angular/core";
import {SideNav} from "../repository/entity/base.entity";
import {BaseRepository} from "../repository/base.repository";
import {Companies} from "../../auth/repository/entity/auth.entity";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  private _supportText = signal("");
  private activeCompanyCode$ = new BehaviorSubject<string>("");

  constructor(private baseRepo: BaseRepository) {
  }

  get activeCompanyCode(): Observable<string> {
    return this.activeCompanyCode$.asObservable();
  }

  set activeCompanyCode(value: string) {
    localStorage.setItem("company_code", value);
    this.activeCompanyCode$.next(value);
  }

  get supportingText(): WritableSignal<string> {
    return this._supportText
  }

  set supportingText(value: string) {
    this._supportText.set(value);
  }

  setSupportingText(value: string) {
    this.supportingText = value;
  }

  getSupportingText(): WritableSignal<string> {
    return this.supportingText;
  }

  getCompanyCode(): Observable<string> {
    return this.activeCompanyCode;
  }

  fetchSideNav(): SideNav[] {
    return this.baseRepo.getSideNav();
  }

  checkCompanyCode(companies: Companies[]) {
    this.activeCompanyCode = localStorage.getItem("company_code") ?? companies[0].companyCode;
  }
}
